import {
  startListening,
  trackEvent,
  isAnyOf,
  resetMarketingMeta,
  updateReferrerId,
} from '@bonanza-social/toolkit/state';
import {
  fetchRegistrationConfig,
  removeStep,
  restoreStep,
  skipStep,
} from '../registrationConfig/registrationConfig.slice';
import {
  resetRegistrationData,
  selectRegistrationFormConfigId,
  selectRegistrationFormData,
  selectShouldReturnToSummary,
  setFormDataConfigId,
  setReturnToSummary,
  setValidationErrors,
  updateRegistrationData,
} from './registrationForm.slice';
import {
  fetchRegistrationOffers,
  selectReferralRegistrationOffer,
  selectWelcomeGenericOffers,
} from '../registrationOffers/registrationOffers.slice';
import { industriesWithoutOccupation } from './registrationForm.constants';
import {
  getValidationErrors,
  mapRegistrationCompletedEventData,
} from './registrationForm.utils';
import { submitSocialRegistrationForm } from './socialRegistrationForm.slice';

startListening({
  actionCreator: fetchRegistrationConfig.fulfilled,
  effect: (action, { dispatch, getState }) => {
    const configId = action.payload.data.id;
    const state = getState();
    const formDataConfigId = selectRegistrationFormConfigId(state);

    if (!formDataConfigId) {
      dispatch(setFormDataConfigId(configId));
    } else if (configId !== formDataConfigId) {
      dispatch(resetRegistrationData());
      dispatch(resetMarketingMeta());
      dispatch(setFormDataConfigId(configId));
    }
  },
});

startListening({
  actionCreator: fetchRegistrationOffers.fulfilled,
  effect: (action, { dispatch, getState }) => {
    const state = getState();
    const { promoId } = selectRegistrationFormData(state);

    const promos = action.payload.items;
    const firstPromo = action?.payload?.items?.[0];
    const welcomeGenericOffers = selectWelcomeGenericOffers()(state);
    const referralPromo = selectReferralRegistrationOffer()(state);

    if (
      !promoId ||
      !promos.find(({ promotionId }) => promotionId === promoId)
    ) {
      if (promos?.length === 1 && !referralPromo) {
        dispatch(
          updateRegistrationData({
            promoId: action?.payload?.items[0].promotionId,
          }),
        );
      } else if (promos?.length === 1 && referralPromo) {
        dispatch(
          updateRegistrationData({
            promoId: undefined,
          }),
        );
      } else if (promos?.length === 2 && firstPromo?.promoType === 'Referral') {
        dispatch(
          updateRegistrationData({
            promoId: action?.payload?.items[1].promotionId,
          }),
        );
      } else if (promos.length) {
        dispatch(updateRegistrationData({ promoId: -1 }));
      }
    }

    if (firstPromo?.subTypeMeta?.referrerId) {
      dispatch(updateReferrerId(firstPromo?.subTypeMeta?.referrerId));
    }

    if (
      !promos.length ||
      (promos.length &&
        firstPromo.promoType !== 'Referral' &&
        firstPromo.subPromoType !== 'Referral')
    ) {
      dispatch(removeStep('intro'));
    }

    if (welcomeGenericOffers.length < 2) {
      dispatch(removeStep('offer'));
    }
  },
});

startListening({
  matcher: isAnyOf(updateRegistrationData, resetRegistrationData.fulfilled),
  effect: (_, { dispatch, getState }) => {
    const state = getState();
    const data = selectRegistrationFormData(state);
    const errors = getValidationErrors(data);
    const returnToSummary = selectShouldReturnToSummary(state);

    dispatch(setValidationErrors(errors));

    if (Object.keys(errors).length > 0 && returnToSummary) {
      dispatch(setReturnToSummary(false));
    }
  },
});

startListening({
  actionCreator: updateRegistrationData,
  effect: (action, { dispatch, getState }) => {
    if (!action.payload.industry) {
      return;
    }

    const industry =
      action.payload.industry.charAt(0).toUpperCase() +
      action.payload.industry.slice(1).toLowerCase();

    if (industriesWithoutOccupation.includes(industry)) {
      dispatch(updateRegistrationData({ occupation: industry }));
      dispatch(skipStep('occupation'));
    } else {
      const state = getState();
      const formData = selectRegistrationFormData(state);

      if (industriesWithoutOccupation.includes(formData.occupation)) {
        dispatch(updateRegistrationData({ occupation: '' }));
      }
      dispatch(setReturnToSummary(false));
      dispatch(restoreStep('occupation'));
    }
  },
});

startListening({
  actionCreator: submitSocialRegistrationForm.fulfilled,
  effect: (action, { dispatch }) => {
    const params = mapRegistrationCompletedEventData(action.payload);

    dispatch(trackEvent({ name: 'registration_process_completed', params }));
  },
});
